import React, { Component } from 'react';
import * as algoliasearch from 'algoliasearch';
import { Label, Image, } from 'semantic-ui-react'
import Select from 'react-select';

class PhoneCaseOrderParts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manufaOptions: [],
        }
        this.client = algoliasearch('FV5Z3H1RLH', '837deba1029595bbad3d5d1df9dabfeb');
        this.index = this.client.initIndex('phoneManufas');
    }

    componentDidMount() {
        //this.loadManufasAlgolia();
    }


    // getPhoneModels = (phoneManufa) => {
    //     this.index.searchForFacetValues({ facetName: 'manufa', facetQuery: '' }).then(content => {
    //         console.log("aglx13:" + JSON.stringify(content.facetHits, null, 3));
    //         this.populateManufaSelections(content.facetHits);
    //     }).catch(function (err) {
    //         console.log(err);
    //         console.log(err.debugData);
    //     });
    // }

    render() {

        const phoneManufaDropdown = <div>
            <Label pointing='below' color='blue'>{'Please select your phone Manufacterer?'}</Label>
            <Select
                name="form-field-name"
                value={this.props.phoneManufa}
                options={this.props.manufaOptions}
                onChange={this.props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
                required={true}
            />
        </div>

        const phoneModelDropdown = this.props.phoneManufa !== ''
            ? <div>
                <Label pointing='below' color='blue'>{'Please select your phone Model?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.phoneModel}
                    options={this.props.phoneModelOptions}
                    onChange={this.props.handleOrderDetailsDropDownChanges}
                    searchable={false}
                    clearable={false}
                    required={true}
                />
            </div>
            : ''

        const phoneImage = this.props.phoneImageUrl && this.props.phoneImageUrl !== ''
            ? <Image src={this.props.phoneImageUrl} size='medium' centered />
            : ''

        return (<div>
            {phoneManufaDropdown}
            <br />
            {phoneModelDropdown}
            <br />
            {phoneImage}
        </div>);
    }
}

export default PhoneCaseOrderParts;


// WEBPACK FOOTER //
// ./src/components/newSite/phoneCase/PhoneCaseOrderParts.js